export const PreviewFooter = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="preview__footer">
      <div className="preview__footer__content">{children}</div>
    </div>
  );
};
